export const WEEKLY_ROUTINE_OPTIONS = [1, 3, 5] as const;
export type WeeklyRoutineOption = (typeof WEEKLY_ROUTINE_OPTIONS)[number];

/** Opción marcada como recomendada (badge + selección por defecto). */
export const RECOMMENDED_WEEKLY_ROUTINE: WeeklyRoutineOption = 3;

export interface WeeklyRoutineSelectorHandle {
  /** Opción seleccionada o null si el alumno aún no ha elegido. */
  getSelected: () => WeeklyRoutineOption | null;
  /** True cuando hay una opción seleccionada (es decir, el flujo puede avanzar). */
  isValid: () => boolean;
}

export interface WeeklyRoutineSelectorProps {
  /** Valor inicial (típicamente la meta semanal actual del alumno). */
  defaultValue?: WeeklyRoutineOption;
  /** Deshabilita interacciones — típicamente mientras el padre guarda. */
  disabled?: boolean;
  /** Notifica cuando la validez (selección != null) cambia. */
  onValidityChange?: (isValid: boolean) => void;
}
